var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_73_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.27 70.8595C49.09 70.8595 47.28 69.1895 47.09 67.0195L43.5 24.9295C43.11 20.3995 46.69 16.5095 51.23 16.5095C55.77 16.5095 59.34 20.3895 58.96 24.9095L55.44 67.0095C55.26 69.1895 53.45 70.8595 51.27 70.8595Z",
    fill: "#1CC3A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.23 86.5896C54.5547 86.5896 57.25 83.8943 57.25 80.5696C57.25 77.2448 54.5547 74.5496 51.23 74.5496C47.9052 74.5496 45.21 77.2448 45.21 80.5696C45.21 83.8943 47.9052 86.5896 51.23 86.5896Z",
    fill: "#1CC3A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.23 99.9595C78.1428 99.9595 99.96 78.1423 99.96 51.2295C99.96 24.3167 78.1428 2.49951 51.23 2.49951C24.3172 2.49951 2.5 24.3167 2.5 51.2295C2.5 78.1423 24.3172 99.9595 51.23 99.9595Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73_1444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102.46,
    height: 102.46,
    fill: "white",
    transform: "translate(0 -0.000488281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIco);
export default __webpack_public_path__ + "static/media/error-ico.59923d9d7185df452007bef14e375f2c.svg";
export { ForwardRef as ReactComponent };